import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { EDateType } from '../../../../../../../../const';

export const onDateSelected = (
    dateType: EDateType
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (dateType === EDateType.DUE_DATE) {
            dispatch(segmentTrackAction(SegmentCardEvent.DUE_DATE_SELECTED));
        } else {
            dispatch(segmentTrackAction(SegmentCardEvent.START_DATE_SELECTED));
        }
    };
    return action;
};
